
import { RevIllustration } from '@ds/components/Illustration'
import { mapGetters } from 'vuex'

import {
  getAdvertisingOptionsFromComponent,
  searchPaymentAdvertising,
} from '@payment'

export default {
  components: {
    RevIllustration,
  },
  computed: {
    ...mapGetters({
      paymentMethods: 'countryConfig/paymentMethods',
    }),

    advertising() {
      return searchPaymentAdvertising(
        this.paymentMethods,
        getAdvertisingOptionsFromComponent(this),
      )
    },
  },
}
